module.exports = __webpack_public_path__ + "static/power-img3-2@2x-af942091c6b308ae1761106d2a2bcf1f.png";